import { render, staticRenderFns } from "./respApplyCrossAppealInstructions.vue?vue&type=template&id=4b119420"
import script from "./respApplyCrossAppealInstructions.vue?vue&type=script&lang=ts"
export * from "./respApplyCrossAppealInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports